<template>
  <div class="w-full">
    <div class="w-full h-full">
      

      <section class="px-4 mt-4 border-b border-b-white/20 pb-4 flex justify-center items-center">
        <div class="w-full md:max-w-full max-w-md">
          <p class="mb-2 text-sm text-woodsmoke-300 uppercase tracking-widest font-semibold">Ongoing Claims</p>

        <div class="flex space-x-2 flex-wrap">

          <template v-if="accountDataLoading">

            <div class="flex space-x-2">
              <div v-for="i in 6" class="w-10 h-10 flex-shrink-0 bg-white/5 rounded-full skeleton"> </div>
            </div>
          
          </template>
          <template v-else>
            <div @click="goToClaimPage(project)" v-for="project in accountData?.vestings?.projects" :key="project" class="w-10 h-10 rounded-full flex-shrink-0 bg-white/10 overflow-hidden border border-white/10 hover:scale-110 duration-300">
              <img :src="project.project_logo" />
            </div>
  
            <div class="mb-4" v-if="!(accountData?.vestings?.projects?.length > 0)">
              <p class="py-2" >No Ongoing Claims</p>
            </div>
          </template>

        </div>
        </div>
      </section>

      <section class="w-full border-t border-t-woodsmoke-800 pb-8">
        <div class="p-4">
          <p class="text-sm text-woodsmoke-300 uppercase tracking-widest font-semibold">Contribution History</p>
        </div>

        <div v-if="projectHistoryListLoading" class="">
          <div v-for="i in 6" :class="[i %2 == 0 ?'bg-woodsmoke-850':'bg-woodsmoke-900']" class="w-full h-20 rounded-none  border-b border-b-white/10 skeleton flex justify-between items-center p-4">
            <div class="w-12 h-12 rounded-md bg-white/5 skeleton"></div>
            <div class="w-20 h-10 rounded-md  bg-white/5 skeleton"></div>
          </div>
        </div>
        <template v-else>
          <ContributionHistoryProject v-for="(i, index) in projectHistoryList" :key="i" :index="index" :pool="i"></ContributionHistoryProject>
        </template>
      </section>
    </div>
  </div>
</template>

<script setup>

  // import { useUserStore } from "~/stores/user.js";
  // const userStore = useUserStore();
  
  // import { config } from "~/wagmiConfig.js";
  // import { getAccount, watchConnections } from "@wagmi/core";

  import { query, queryNoCache } from "~/apollo";
  import { gql } from "@apollo/client/core";

  const router = useRouter();

  const { $address, $accessToken } = useNuxtApp();
  
  
  
  // const address = ref("");
  // const chainId = ref("");
  
  // const unwatch = watchConnections(config, {
  //     onChange(data) {
  //         if (data) {
  //             let _account = getAccount(config);
  //             chainId.value = _account.chainId;
  //             address.value = _account.address;
  //         } else {
  //             address.value = null;
  //         }
  
  //         renderView();
  //     },
  // });
  
  // const unsub = userStore.$subscribe((state) => {
  //     renderView();
  // });

  // watch( userStore.accessToken, () => {
  //   renderView();
  // })
  
  // onUnmounted(() => {
  //     unwatch();
  //     unsub();
  // });
  
  onMounted(() => {
      // let _account = getAccount(config);
      // chainId.value = _account.chainId;
      // address.value = _account.address;
  
      renderView();

      watch($address, () => {
        renderView();
      })

      watch($accessToken, () => {
        renderView();
      })
  })

  const projectHistoryList = ref([]);
  const projectHistoryListLoading = ref(true);
  const accountDataLoading = ref(true);

  const fetchHistory = async () => {

    projectHistoryListLoading.value = true;

    let result = (
      await query(
        gql`
          query GetContributionHistoryByProject {
            getContributionHistoryByProject {
              total_initial_contribution
              total_refund
              total_effective_contribution
              project {
                project_id
                project_name
                project_logo
                project_status
                is_concluded
              }
              pools {
                effective_contribution
                refund
                guarantee_allocation
                allocation_fee
                pool_name
                contrib_max
                contrib_min
                pool_id
                pool_round
                chain
                pool_desc
                currency_symbol
                contrib_activity {
                  transactionHash
                  tokenAmountEtherNumber
                }
              }
              transaction_activity {
                transactionHash
                userAddress
                tokenAmountEtherNumber
                pool_id
                project_id
              }
            }
          }
        `
      )
    )
    
    // ["getContributionHistoryByProject"];

    // console.log(result)
    projectHistoryList.value = result['getContributionHistoryByProject']
    projectHistoryListLoading.value = false;
  }

  const accountData = ref(null);

  const fetchAccount = () => {
  return new Promise( async (resolve) => {

    accountDataLoading.value = true;

    let gqlResult = await queryNoCache(
      gql`
      query User($limit: Int, $after: Int) {
          user(limit: $limit, after: $after) {
            vestings {
                    max
                    cursor
                    projects {
                      project_id
                      project_name
                      project_logo
                      project_index
                    }
                  }
          }
        }
      `,
      {
        limit: 6,
        after: null,
      }

      // gql`
      //   query userVestingClaimable {
      //     userVestingClaimable {
      //         max
      //         cursor
      //         projects {
      //           project_id
      //           project_name
      //           project_logo
      //           project_index
      //         }
            
      //     }
      //   }
      
      // `,
      // {}

    );

    // console.log('gqlResult gqlResult', gqlResult);

    accountData.value = gqlResult["user"];
    accountDataLoading.value = false;

    resolve();
  })
}

let throttle = false;
  
  const renderView = async () => {

    let main = async () => {
      projectHistoryList.value = [];
      accountData.value = null;

      if($accessToken.value) {
        await fetchHistory();
        await fetchAccount();

        // console.log(projectHistoryList.value);
      }
    }

    if(throttle){
      clearTimeout(throttle);
    }

    throttle = setTimeout(() => {
      main();
    }, 500);
  }

  const goToClaimPage = async (_project) => {
    await router.push({ path: `/app/project/${_project?.project_id}` });
  };



</script>

<style>

</style>